import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingConceptDataType,
    getConceptDataTypeById,
    saveConceptDataType,
    updateConceptDataType,
    deleteConceptDataType
} from 'app/services/ConceptDataTypeService';

import { ConceptType } from "app/common/Model/ConceptType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import i18n from 'i18n';

export default class ConceptTypeDataStore {
    listAllConceptDataType = [];
    searchConceptDataType = new SearchObject();
    pageConceptDataType = null;
    selectedConceptDataType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteConceptDataType = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllConceptDataType = async () => {
        if (this.listAllConceptDataType?.length) return;
        const searchObjectForAll = {
            pageIndex: 1,
            pageSize: 1000000,
        };
        return await pagingConceptDataType(searchObjectForAll)
            .then(({ data }) => {
                this.listAllConceptDataType = data?.content;
            }).
            catch((error) => {
                console.error(error);
                toast.error("Lấy kiểu dữ liệu của khái niệm có lỗi");
            })
    }

    pagingConceptDataType = () => {
        pagingConceptDataType(this.searchConceptDataType).then(({ data }) => {
            this.pageConceptDataType = data;
        })
    }

    handleChangeFormSearch = (searchConceptDataType) => {
        this.searchConceptDataType = checkSearchObject(this.searchConceptDataType, searchConceptDataType);
        this.pagingConceptDataType();
    }

    handleOpenFormCreateOrEdit = (conceptDataTypeId) => {
        if (Boolean(conceptDataTypeId)) {
            getConceptDataTypeById(conceptDataTypeId).then(({ data }) => {
                this.selectedConceptDataType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error(i18n.t("management.conceptDataType.getDataFail"));
            });
        } else {
            this.selectedConceptDataType = new ConceptType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptDataType = async (conceptDataType, { setSubmitting }) => {
        return await saveConceptDataType(conceptDataType)
            .then(() => {
                this.selectedConceptDataType = null;
                toast.success(i18n.t("management.conceptDataType.saveSuccess"));
                this.pagingConceptDataType();
                this.handleClosePopup();
            })
            .catch(function (error) {
                console.error(error);
                toast.error(i18n.t("management.conceptDataType.saveFail"));
            })
            .finally(function () {
                setSubmitting(false);
            });
    }

    updateConceptDataType = async (conceptDataType, { setSubmitting }) => {
        return await updateConceptDataType(conceptDataType).then(() => {
            this.selectedConceptDataType = null;
            toast.success(i18n.t("management.conceptDataType.updateSuccess"));
            this.pagingConceptDataType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptDataType.updateFail"));
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteConceptDataType = (conceptDataType) => {
        this.selectedConceptDataType = { id: conceptDataType?.id };
        this.openConfirmDeleteConceptDataType = true;
    }

    handleConfirmDeleteConceptDataType = () => deleteConceptDataType(this.selectedConceptDataType?.id).then(() => {
        if (this.searchConceptDataType?.pageIndex > 1 && this.pageConceptDataType?.content?.length === 1) {
            this.searchConceptDataType.pageIndex -= 1;
        }
        toast.success(i18n.t("management.conceptDataType.deleteSuccess"));
        this.pagingConceptDataType();
        this.handleClosePopup();
    }).catch(function (error) {
        console.error(error);
        toast.error(i18n.t("management.conceptDataType.deleteFail"));
    })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptDataType = false;
    }

    resetStore = () => {
        this.searchConceptDataType = new SearchObject();
        this.pageConceptDataType = null;
        this.selectedConceptDataType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptDataType = false;
    }
}